import * as Three from 'three';

export function normalizeColor(color: string): Three.Color {
  return new Three.Color().setStyle(color);
}
